import {view} from '@sail/ui';

interface Props {
  children: React.ReactNode;
}

export function FormContainer({children}: Props) {
  return (
    <view.div
      css={{
        background:
          'linear-gradient(45deg, #55DDFF -20.36%, #675DFF 54.28%, #28239B 125.93%)',
        borderRadius: 'large',
        padding: '1px',
      }}
    >
      <view.div
        css={{
          backgroundColor: 'surface',
          borderRadius: '11px',
          width: 'fill',
          height: 'fill',
          padding: '16px',
        }}
      >
        {children}
      </view.div>
    </view.div>
  );
}
